/**
 * API Error class for handling HTTP error responses
 */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: Record<string, string[]>
  ) {
    super(message);
    this.name = 'ApiError';
  }

  static fromResponse(status: number, body: unknown): ApiError {
    if (typeof body === 'object' && body !== null) {
      const { code, message, details } = body as Record<string, unknown>;
      return new ApiError(
        status,
        (code as string) || 'unknown_error',
        (message as string) || 'An unexpected error occurred',
        details as Record<string, string[]>
      );
    }
    return new ApiError(status, 'unknown_error', 'An unexpected error occurred');
  }

  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  get isForbidden(): boolean {
    return this.status === 403;
  }

  get isNotFound(): boolean {
    return this.status === 404;
  }

  get isRateLimited(): boolean {
    return this.status === 429;
  }

  get isServerError(): boolean {
    return this.status >= 500;
  }
}

/**
 * Network Error class for handling connection failures
 */
export class NetworkError extends Error {
  constructor(message: string = 'Network error - please check your connection') {
    super(message);
    this.name = 'NetworkError';
  }
}
